import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Student } from 'services';
import { Results } from './components';
import { account_manager } from 'utils/constants';
const StudentList = props => {

  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="All Students" subheader="Student Management" {...rest} >
      </GenericHeader>
    );
  }

  return (
    <ListComp
      listing={Student.list}
      title="Students"
      name="students"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      roles={[account_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "" }}
    />
  );
};

export default StudentList;
